import React from "react";
import { DoorOpen, Inbox, Phone } from "lucide-react";
import { NOT_FOR } from "../shared/notForContent.js";

const ICONS = {
  inbox: Inbox,
  phone: Phone,
  door: DoorOpen,
};

const NotForSection = () => (
  <section className="cursor-section roofing-not-for" data-testid="roofing-not-for-section">
    <div className="cursor-container roofing-not-for-inner">
      <p className="roofing-not-for-badge">{NOT_FOR.badge}</p>
      <h2 className="roofing-not-for-title" data-testid="roofing-not-for-headline">
        {NOT_FOR.headline.map((part) =>
          part.tone ? (
            <span key={part.text} className={`roofing-not-for-${part.tone}`}>
              {part.text}
            </span>
          ) : (
            <span key={part.text}>{part.text}</span>
          )
        )}
      </h2>
      <ul className="roofing-not-for-grid">
        {NOT_FOR.items.map((item) => {
          const Icon = ICONS[item.icon];
          return (
            <li key={item.icon} className="roofing-not-for-card">
              <p className="roofing-not-for-label">
                <Icon className="roofing-not-for-icon" strokeWidth={1.5} aria-hidden="true" />
                {NOT_FOR.label}
              </p>
              <h3 className="roofing-not-for-card-title">{item.lead}</h3>
              <p className="roofing-not-for-card-text">{item.text}</p>
            </li>
          );
        })}
      </ul>
    </div>
  </section>
);

export default NotForSection;
